import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import IntegrityRoleGrid from '../../../../components/UserRole';
import IntegrityProfCourseGrid from '../../../profCourse/component/IntegrityProfCourseGrid';
import useLoadProfCourseById from '../../../profCourse/hooks/useLoadProfCourseById';
const ProfCourseGrid = ({id}: any) => {
  const loadProfCourse = useLoadProfCourseById(id);

  return (
    <IntegrityRoleGrid
      dataSource={loadProfCourse}
      id={['iD_ProfileSpac', 'iD_Course']}
      allowExport={true}
      integrityGrid={IntegrityProfCourseGrid}
      integrityId={['ID_Course', 'ID_ProfileSpac']}
      integrityName={'ProfCourse'}
      exportName="ProfCourse-export"
      allowActions={false}
    >
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" />
      <Column caption={i18n2._('Curso')} dataField="name_Course" />
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('SPAC')} dataField="spac" />
      <Column caption={i18n2._('Nombre del SPAC')} dataField="name_Spac" />
      <Column caption={i18n2._('Perfil Spac')} dataField="name_ProfSpac" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default ProfCourseGrid;
